export default "__VITE_ASSET__b2f4b3f3__"